module.exports = __webpack_public_path__ + "5b10eb67df86dfb310feb293c3380d8d.pdf";